import { FC } from "react";
import { observer } from "mobx-react-lite";
import * as M from "moment";

import Constants from "../../../constants/Common";
import DefectCardItem from "./cardItem";
import DefectCardStatusItem from "./cardStatusItem";
import DefectUploadFiles from "./defectUploadFiles/defectUploadFiles";

import { EVENT_TYPE_PLANNING_ID } from "../../DefectForm/constants";

import styles from "../Defect.module.scss";
interface CardPowerSupplyProps {
  data: any;
  handleOpenPopupDefect: () => void;
}

const CardPowerSupply: FC<CardPowerSupplyProps> = observer(
  ({ data, handleOpenPopupDefect }) => {
    return (
      <>
        <DefectCardStatusItem
          label="Статус"
          value={data.incidentStatus?.title}
          handleOpenPopupDefect={handleOpenPopupDefect}
        />
        <DefectCardItem
          label="Комментарий к статусу"
          value={data.statusComment}
        />
        <DefectCardItem
          label={
            data.eventTypeId === EVENT_TYPE_PLANNING_ID
              ? "ID планового события"
              : "ID дефекта"
          }
          value={data.externalId}
        />
        <DefectCardItem label="Тип сети" value={data.gridType?.title} />
        <DefectCardItem label="Тип события" value={data.eventType?.title} />
        <DefectCardItem label="Организация" value={data.organization?.name} />
        <DefectCardItem
          label="Дата и время отключения/ограничения"
          value={
            data.dateTimeDisable
              ? M(data.dateTimeDisable).format(Constants.dateTimeFormat)
              : ""
          }
        />
        <DefectCardItem
          label={
            data.eventTypeId === EVENT_TYPE_PLANNING_ID
              ? "Дата и время завершения планового события"
              : "Дата и время устранения дефекта"
          }
          value={
            data.dateTimeEnable
              ? M(data.dateTimeEnable).format(Constants.dateTimeFormat)
              : ""
          }
        />
        <DefectCardItem
          label="ID объекта"
          value={data.objectShortName ? data.objectShortName : ""}
        />
        <DefectCardItem
          label="Административный район"
          value={data.district?.title}
        />
        <DefectCardItem
          label={
            data.eventTypeId === EVENT_TYPE_PLANNING_ID
              ? "Адрес планового события"
              : "Адрес дефекта"
          }
          value={data?.addressText}
        />
        <DefectCardItem label="Примечание к адресу" value={data?.addressNote} />
        <DefectCardItem
          label="Адреса отключ. зданий или с ограничениями по ЦО"
          value={data?.addressDisconnexionList
            ?.map((address) => address.text)
            .join("\n")}
        />
        <DefectCardItem
          label="Количество отключенных абонентов"
          value={data.disconnectedSubscribers}
        />
        <DefectCardItem label="Место работ" value={data.placeOfWorkText} />
        <DefectCardItem
          label="Характер неисправности"
          value={data.lightingProblemType?.title}
        />
        <DefectCardItem
          label="Произведенная работа"
          value={data.producedWork?.title}
        />
        <DefectCardItem label="Вид работ" value={data.workType?.title} />
        <DefectCardItem
          label="Уточнение вида работ"
          value={data.clarifiedWorkType}
        />
        <DefectCardItem
          label="Дата начала работ"
          value={
            data.dateTimeWorkStarted
              ? M(data.dateTimeWorkStarted).format(Constants.dateFormat)
              : ""
          }
        />
        <DefectCardItem
          label="Время начала работ"
          value={
            data.lightingWorkStartedTime ? data.lightingWorkStartedTime : ""
          }
        />
        {/* <DefectCardItem
          label="Планируемая дата и время завершения работ"
          value={
            data.dateTimePlanned
              ? M(data.dateTimePlanned).format(Constants.dateTimeFormat)
              : ""
          }
        />
        <DefectCardItem
          label="Нормативное время, ч"
          value={data.standartTime}
        /> */}
        <DefectCardItem label="Ответственный" value={data.responsible} />
        <DefectCardItem
          label="Телефон ответственного"
          value={data.responsiblePhone}
        />
        <DefectCardItem label="Комментарий" value={data.comment} />

        {data.files.length > 0 && <DefectUploadFiles data={data} />}
      </>
    );
  },
);

export default CardPowerSupply;
